module.exports = __webpack_public_path__ + "img/bg_main05_mask.25bad113.png";